import { PropsWithChildren, useState, createContext } from 'react';
import { StoreApi } from 'zustand';

import { RouterStore } from '../../stores/router/types';
import { createRouterStore } from '../../stores/router/createRouterStore';

export interface WidgetStores {
  routerStore: StoreApi<RouterStore>;
}

export const StoresContext = createContext<WidgetStores | undefined>(undefined);

export const StoresProvider = ({ children }: PropsWithChildren<{}>) => {
  const [routerStore] = useState(() => createRouterStore());

  return <StoresContext.Provider value={{ routerStore }}>{children}</StoresContext.Provider>;
};
